export const COLOR_WHITE = "--marker-color-white";
export const COLOR_PRIMARY = "--marker-color-primary";
export const COLOR_SECONDARY = "--marker-color-secondary";
export const COLOR_GRAY = "--marker-color-gray";
export const COLOR_HIGHLIGHT = "--marker-color-highlight";